<template>
    <div class="form">

        <!-- Travel mode options -->
        <div class="form__section">
            <div class="form__title">Bevorzugte Strecke</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.travelMode" 
                        :options="travelModeOptions"
                        :singleChoice="true"
                        :tracking-data-label="'Car'"
                        :tracking-data-category="'Route Planner'"
                        :tracking-data-ga4-event="'route_planner_settings'"
                        @change="fieldChangeHandler($event, 'travelMode')"
                    />
                </div>
            </div>
        </div>

        <!-- Avoid options -->
        <div class="form__section">
            <div class="form__title">Straßen ausschließen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.avoid" 
                        :options="avoidOptions"
                        :tracking-data-label="'Car'"
                        :tracking-data-category="'Route Planner'"
                        :tracking-data-ga4-event="'route_planner_settings'"
                        @change="fieldChangeHandler($event, 'avoid')"
                    />
                </div>
            </div>
        </div>

        <!-- Avoid tunnels options -->
        <div class="form__section">
            <div class="form__title">Tunnel vermeiden</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrPills 
                        :values="data.avoidTunnels" 
                        :options="avoidTunnelsOptions"
                        :single-choice="true"
                        :allowNoSelection="true"
                        :tracking-data-label="'Car'"
                        :tracking-data-value="'avoid_tunnel'"
                        :tracking-data-category="'Route Planner'"
                        :tracking-data-ga4-event="'route_planner_settings'"
                        @change="fieldChangeHandler($event, 'avoidTunnels')"
                    />
                </div>
            </div>
        </div>
        

        <!-- Avoid countries -->
        <div class="form__section">
            <div class="form__title">Länder nicht durchfahren</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrSelect 
                        :options="avoidCountriesOptions" 
                        :value="data.avoidCountries" 
                        :clearable="false" 
                        :output-array="true"
                        :tracking-data="trackingData"
                        :tracking-data-ga4-event="'route_planner_settings'"
                        :multiple="true"
                        placeholder="Wählen Sie Länder, die nicht durchfahren werden sollen"
                        @change="fieldChangeHandler($event, 'avoidCountries')"
                    />
                </div>
            </div>
        </div>
        
        <!-- Gas Price -->
        <div class="form__section">
            <div class="form__title">Mein Sprit-Verbrauch</div>
            <div class="form__fields">
                <div class="form__field-row form__field-row--half ui-spread-center-vertically">
                    <div class="copy black">Preis pro Liter <span class="copy-light">(€)</span></div>
                    <SmrInput
                        class="smr-input--small"
                        :value="data.gasPrice"
                        placeholder="0,0"
                        inputType="number"
                        @change="fieldChangeHandler($event, 'gasPrice')">
                    </SmrInput>
                </div>
                <div class="form__field-row form__field-row--half ui-spread-center-vertically">
                    <div class="copy black">Verbrauch pro 100 km <span class="copy-light">(l)</span></div>
                    <SmrInput
                        class="smr-input--small"
                        :value="data.gasConsumption"
                        placeholder="0,0"
                        inputType="number"
                        @change="fieldChangeHandler($event, 'gasConsumption')">
                    </SmrInput>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import COUNTRIES from '@/data/countries'
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
import SmrSelect from '@/components/form/SmrSelect.vue'
import SmrPills from '@/components/form/SmrPills.vue'
import SmrInput from '@/components/form/SmrInput.vue'

export default {
    components: {
        SmrChoiceGroup,
        SmrSelect,
        SmrPills,
        SmrInput,
    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            travelModeOptions: [
                {value: 'FASTEST', label: 'Schnellste Strecke', trackingLabel: 'Fastest route'},
                {value: 'SHORTEST', label: 'Kürzeste Strecke', trackingLabel: 'Shortest route'},
            ],
            avoidOptions: [
                {value: 'motorway', label: 'Autobahnen vermeiden', trackingLabel: 'Avoid Motorway'},
                {value: 'vignette', label: 'Vignettenpflicht vermeiden', trackingLabel: 'Avoid Vignette'},
                {value: 'toll', label: 'Mautstraßen vermeiden', trackingLabel: 'Avoid Toll'},
                {value: 'ferry', label: 'Fähren vermeiden', trackingLabel: 'Avoid Ferry'},
            ],
            avoidTunnelsOptions: [
                {value: '0', label: 'Alle', trackingLabel: 'Avoid Tunnel Alle', trackingValue: 'all'},
                {value: '500', label: 'Länger als 500m', trackingLabel: 'Avoid Tunnel 500m', trackingValue: '500m'},
                {value: '1000', label: 'Länger als 1000m', trackingLabel: 'Avoid Tunnel 1000m', trackingValue: '1000m'},
                {value: '5000', label: 'Länger als 5000m', trackingLabel: 'Avoid Tunnel 5000m', trackingValue: '5000m'},
            ],
            avoidCountriesOptions: COUNTRIES,
            trackingData: {
                category: 'Route Planner',
                action: 'Settings',
                label: 'Car: Avoid Country',
                value: 'avoid_country',
                value2: 'car',
            },
        }
    },
}
</script>
